export const SortButton = ({
  sortOrder,
  columnKey,
  sortKey,
  onClick,
  bgColor,
}) => {
  return (
    <button
      onClick={onClick}
      className={`${
        sortKey === columnKey && sortOrder === "desc"
          ? "sort-button sort-reverse"
          : "sort-button"
      }`}
      style={{ color: bgColor || "" }}
    >
      ▲
    </button>
  );
};

export const sortData = ({ tableData, sortKey, reverse, data }) => {
  if (!sortKey) return tableData;

  const sortedData = data.sort((a, b) => {
    return a[sortKey] > b[sortKey] ? 1 : -1;
  });

  if (reverse) {
    return sortedData.reverse();
  }

  return sortedData;
};
